import script from "./PropertyDocumentTab.vue?vue&type=script&setup=true&lang=js"
export * from "./PropertyDocumentTab.vue?vue&type=script&setup=true&lang=js"

import "./PropertyDocumentTab.vue?vue&type=style&index=0&id=4e444672&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e444672"]])

export default __exports__